'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildCanonicalUrlWithPageNum = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _url = require('./url');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildCanonicalUrl = function buildCanonicalUrl(canonicalPageUrl, pageNum) {
    var base = (0, _url.getBase)(canonicalPageUrl);
    var originalQuery = (0, _url.getQueryString)(canonicalPageUrl);
    var params = (0, _url.getParams)(originalQuery);

    var withPage = (0, _extends3.default)({}, params);

    // remove parameters for search page
    delete withPage.parameters;

    // remove page (we will add it later)
    delete withPage.page;
    if (pageNum && pageNum !== 1) {
        withPage.page = pageNum;
    }

    var query = (0, _url.toQueryString)(withPage);

    return query === '' ? base : base + '?' + query;
};

var buildCanonicalUrlWithPageNum = exports.buildCanonicalUrlWithPageNum = function buildCanonicalUrlWithPageNum(canonicalPageUrl, pageNum) {
    return buildCanonicalUrl(canonicalPageUrl, pageNum);
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/canonical.js
// module id = 5QdQ
// module chunks = 57